import React, { useState } from 'react';
import { Trophy, RefreshCcw, FileDown } from 'lucide-react';

export default function MarcadorPadel() {
  const [juegos, setJuegos] = useState({ A: 0, B: 0 });
  const [sets, setSets] = useState({ A: 0, B: 0 });
  const [puntos, setPuntos] = useState({ A: 0, B: 0 });
  const [ventaja, setVentaja] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [teamNames, setTeamNames] = useState({ A: 'Equipo A', B: 'Equipo B' });

  const puntoLabels = [0, 15, 30, 40];

  const handleNameChange = (equipo, value) => {
    setTeamNames((prev) => ({ ...prev, [equipo]: value }));
  };

  const sumarPunto = (equipo) => {
    setPuntos((prev) => {
      const otro = equipo === 'A' ? 'B' : 'A';

      if (prev[equipo] >= 3 && prev[otro] >= 3) {
        if (ventaja === equipo) {
          sumarJuego(equipo);
          return { A: 0, B: 0 };
        } else if (ventaja === otro) {
          setVentaja(null);
          return prev;
        } else {
          setVentaja(equipo);
          return prev;
        }
      }

      const nuevoPunto = prev[equipo] + 1;
      if (nuevoPunto > 3) {
        sumarJuego(equipo);
        return { A: 0, B: 0 };
      }

      return { ...prev, [equipo]: nuevoPunto };
    });
  };

  const sumarJuego = (equipo) => {
    setJuegos((prev) => {
      const nuevos = prev[equipo] + 1;
      if (nuevos >= 6 && nuevos - prev[equipo === 'A' ? 'B' : 'A'] >= 2) {
        sumarSet(equipo);
        return { A: 0, B: 0 };
      }
      return { ...prev, [equipo]: nuevos };
    });
    setVentaja(null);
  };

  const sumarSet = (equipo) => {
    setSets((prev) => {
      const nuevos = { ...prev, [equipo]: prev[equipo] + 1 };
      guardarResultadoFinal(nuevos);
      return nuevos;
    });
    setJuegos({ A: 0, B: 0 });
    setPuntos({ A: 0, B: 0 });
    setVentaja(null);
  };

  const guardarResultadoFinal = (nuevosSets) => {
    if (nuevosSets.A >= 2 || nuevosSets.B >= 2) {
      const ganador = nuevosSets.A > nuevosSets.B ? teamNames.A : teamNames.B;
      setHistorial((prev) => [
        ...prev,
        {
          fecha: new Date().toLocaleString(),
          resultado: `${nuevosSets.A} - ${nuevosSets.B}`,
          ganador,
          equipos: `${teamNames.A} vs ${teamNames.B}`
        },
      ]);
      alert(`Partido terminado. Ganador: ${ganador}`);
      resetPartido();
    }
  };

  const resetPartido = () => {
    setPuntos({ A: 0, B: 0 });
    setJuegos({ A: 0, B: 0 });
    setSets({ A: 0, B: 0 });
    setVentaja(null);
  };

  const exportarHistorial = () => {
    const csv = "data:text/csv;charset=utf-8," +
      ["Fecha,Resultado,Ganador,Equipos", ...historial.map(h => `${h.fecha},${h.resultado},${h.ganador},${h.equipos}`)].join("\n");
    const link = document.createElement("a");
    link.setAttribute("href", encodeURI(csv));
    link.setAttribute("download", "historial_partidos.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const mostrarPuntos = (equipo) => {
    const otro = equipo === 'A' ? 'B' : 'A';
    if (puntos[equipo] >= 3 && puntos[otro] >= 3) {
      if (ventaja === equipo) return "VENTAJA";
      if (ventaja === otro) return "40";
      return "IGUALES";
    }
    return puntoLabels[puntos[equipo]];
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white flex flex-col items-center p-6">
      <h1 className="text-4xl font-bold mb-8">Marcador de Pádel</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-center text-xl w-full max-w-lg">
        {['A', 'B'].map((equipo) => (
          <div key={equipo}>
            <input
              type="text"
              value={teamNames[equipo]}
              onChange={(e) => handleNameChange(equipo, e.target.value)}
              className="w-full text-center text-lg md:text-2xl font-semibold text-black px-2 py-1 rounded mb-2"
            />
            <p className="text-lg">Sets: {sets[equipo]}</p>
            <p className="text-lg">Juegos: {juegos[equipo]}</p>
            <p className={`text-4xl md:text-5xl font-bold my-4 ${equipo === 'A' ? 'text-blue-400' : 'text-red-400'}`}>
              {mostrarPuntos(equipo)}
            </p>
            <button
              onClick={() => sumarPunto(equipo)}
              className={`p-2 md:p-3 rounded-full w-28 md:w-32 ${equipo === 'A' ? 'bg-blue-500' : 'bg-red-500'} text-white`}
            >
              + Punto {equipo}
            </button>
          </div>
        ))}
      </div>

      <div className="flex gap-4 mt-8">
        <button onClick={resetPartido} className="flex items-center bg-gray-700 p-3 rounded-full">
          <RefreshCcw className="mr-2" /> Reiniciar
        </button>
        <button onClick={exportarHistorial} className="flex items-center bg-yellow-500 p-3 rounded-full text-gray-900">
          <FileDown className="mr-2" /> Exportar
        </button>
      </div>

      <div className="mt-10 w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4 text-center">Historial de Partidos <Trophy className="inline" /></h2>
        <ul className="bg-gray-800 p-4 rounded-xl max-h-64 overflow-y-auto">
          {historial.length === 0 ? (
            <li className="text-gray-400 text-center">Sin registros aún</li>
          ) : (
            historial.map((item, idx) => (
              <li key={idx} className="border-b border-gray-700 py-2">
                {item.fecha} - {item.resultado} - <span className="font-bold">{item.ganador}</span><br />
                <span className="text-gray-400 text-sm">{item.equipos}</span>
              </li>
            ))
          )}
        </ul>
      </div>

      <footer className="mt-10 text-gray-500 text-sm text-center">
        Creado por <span className="font-semibold text-white">ItManagment - Reynaldo Martinez</span>
      </footer>
    </div>
  );
}
